import React from 'react'

const SearchIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="10" cy="10" r="7" stroke="#021A56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M21 21L15 15" stroke="#021A56" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

export default SearchIcon
